import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { formatDate,uniqueRefernce,findItem,LangValue} from './Function';
import { useDepartmentList } from './DynamicUse';
import { useToast } from '../ToastContext';
import { Container,Row,Col,Form,FloatingLabel,InputGroup,Button,Image,Card,Accordion,ListGroup,Stack,Spinner } from 'react-bootstrap';
const Complaint = () => 
{
    const { t } = useTranslation();
    const {addToast} = useToast();
    const appLanguage = (localStorage.getItem('appLanguage') === null) ? 'en' : localStorage.getItem('appLanguage');
    const complaintInfo = global.config.uploadPath+'847708257.png';
    const[isLoading, setLoading] = useState(true);
    const[submitting, setSubmitting] = useState(false);
    const[Complaints,setComplaints]=useState([]);
    const[ComplaintNumber, setComplaintNumber] = useState('');
    const ComplaintNumberChange = (e) => {
        // Restrict reference lookup values strictly to safe alphanumeric characters
        const sanitizedVal = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
        setComplaintNumber(sanitizedVal);
    };
    const[FeedbackTypes,setFeedbackTypes]=useState([]);
    const DepartmentList = useDepartmentList();
    //const[DepartmentList,setDepartmentList]=useState([]);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const saveFeedback = async (data) => {
        setSubmitting(true);
        // 1. Check file validation (type + size)
        if (data.f_file && data.f_file[0]) {
            const file = data.f_file[0];
            const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "image/gif",
            "video/mp4"
            ];

            if (file.size > 5 * 1024 * 1024) {
                addToast("File must be less than 5MB", "danger");
                setSubmitting(false);
                return;
            }

            if (!allowedTypes.includes(file.type)) {
                addToast("Invalid file type", "danger");
                setSubmitting(false);
                return;
            }
        }

        // 2. Prepare feedback data
        const feedbackData = {
            ...data,
            f_date: Math.floor(Date.now() / 1000),
            f_reference: uniqueRefernce(Date.now()),
        };

        // Remove file before sending JSON
        delete feedbackData.f_file;

        try {
            const response = await fetch(global.config.API_URL + "feedback/saveDetails", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(feedbackData)
            });

            const result = await response.json();

            // 3. If feedback saved successfully
            if (result && result.f_id > 0) {
                const feedbackId = result.f_id;
                // 4. Upload file to UploadController (if present)
                if (data.f_file && data.f_file[0]) {
                    const uploadFormData = new FormData();
                    uploadFormData.append("sId", feedbackId);
                    uploadFormData.append("sType", "FeedbackFile");
                    uploadFormData.append("file", data.f_file[0]);
                    uploadFormData.append("allowMulti", 0);

                    const uploadRes = await fetch(global.config.API_URL + "upload/addfile", {
                        method: "POST",
                        body: uploadFormData,
                    });

                    if (uploadRes.ok) {
                        addToast(t("ComplaintSuccess"), "success");
                    } else {
                        addToast("Feedback saved, but file upload failed", "warning");
                    }
                } else {
                    addToast(t("ComplaintSuccess"), "success");
                }
                reset();
            } else {
                addToast(t("ComplaintFailed"), "danger");
            }
            if (global.config.IsPrint) {
                console.info("SaveComplaint Result", result);
            }
        } catch (error) {
            console.error("Error:", error);
            addToast("Something went wrong", "danger");
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => 
    {
        const GetFeedbackTypes = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL + "feedbacktype/list");
                const result = await response.json();
                setFeedbackTypes(result);
                if (global.config.IsPrint === true) { console.info('GetFeedbackTypes : Result', result); }
            } 
            catch (error) 
            {
                console.error('GetFeedbackTypes : Error', error.message);
            }
        };
        GetFeedbackTypes();
    }, []);
    const FeedbackDetail = async (e) => {
        e.preventDefault();

        if (!ComplaintNumber) {
            alert(t("ComplaintAlert"));
            return;
        }

        setLoading(true);

        try {
            const cleanReference = ComplaintNumber.replace(/^#/, "");
            const response = await fetch(
            global.config.API_URL + "feedback/byReference/" + cleanReference
            );
            const result = await response.json();

            if (result.length > 0) {
            // Fetch logs + files for each feedback item in parallel
            await Promise.all(
                result.map(async (feedback, i) => {
                try {
                    // Fetch feedback logs
                    const logsResponse = await fetch(
                    global.config.API_URL + "feedbackLog/byFeedback/" + feedback.f_id
                    );
                    const logs = await logsResponse.json();

                    // Fetch feedback file
                    const fileResponse = await fetch(
                    global.config.API_URL + "upload/details/0/" + feedback.f_id + "/FeedbackFile"
                    );
                    const file = await fileResponse.json();

                    // Assign both to the current result object
                    result[i].logs = logs;
                    result[i].file = file[0] || null;
                } catch (err) {
                    console.error(`Error fetching logs/files for f_id=${feedback.f_id}:`, err);
                    result[i].logs = [];
                    result[i].file = null;
                }
                })
            );

            setComplaints(result);
            } else {
                setComplaints([]);
            }
            if (global.config.IsPrint === true) {
                console.info("FeedbackDetail : Result", result);
            }
        } catch (error) {
            console.error("FeedbackDetail : Error", error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section>
            <Container className='py-5 text-start'>
                <Row>
                    <Col md={7}>
                        <form onSubmit={handleSubmit(saveFeedback)}>
                            <h2 className='text-start'>
                                <i className="bi bi-pencil-square"></i> {appLanguage === 'hi' ? 'नई शिकायत/प्रतिक्रिया बनाएं' : 'Create new complaint/feedback'}
                            </h2>
                            <Row className="">
                                <Col md={6}>
                                    <FloatingLabel controlId="f_ft_id" label={t('FeedbackType')} className="mb-3">
                                        <Form.Select {...register('f_ft_id', { required: appLanguage === 'hi' ? `${t('FeedbackType')} आवश्यक है` : `${t('FeedbackType')} is required` })} isInvalid={errors.f_ft_id}>
                                            <option value="">
                                                {appLanguage === 'hi' ? '-कृपया चुनें-' : '-Please Select-'}
                                            </option>
                                            {FeedbackTypes.map((ft, index) => (
                                                <option value={ft.ft_id} key={index}>
                                                    {appLanguage === 'hi' ? ft.ft_name_hi || ft.ft_name : ft.ft_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.f_ft_id && (
                                            <Form.Control.Feedback type="invalid">{errors.f_ft_id.message}</Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>
                                </Col>
                                <Col md={6}>
                                    <FloatingLabel controlId="f_sd_id" label={t('Departments')} className="mb-3">
                                        <Form.Select {...register('f_sd_id', { required: appLanguage === 'hi' ? `${t('Departments')} आवश्यक है` : `${t('Departments')} is required` })} isInvalid={errors.f_sd_id}>
                                            <option value="">
                                                {appLanguage === 'hi' ? '-कृपया चुनें-' : '-Please Select-'}
                                            </option>
                                            {DepartmentList.map((sd, index) => (
                                                <option value={sd.sd_id} key={index}>
                                                    {appLanguage === 'hi' ? sd.sd_name_hi || sd.sd_name : sd.sd_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.f_sd_id && (
                                            <Form.Control.Feedback type="invalid">{errors.f_sd_id.message}</Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>
                                </Col>                                
                                <Col md={7}>
                                    <FloatingLabel controlId="f_name" label={appLanguage === 'hi' ? 'आपका नाम' : 'Your name'} className="mb-3">
                                        <Form.Control type="text" {...register('f_name', { required: appLanguage === 'hi' ? 'आपका नाम आवश्यक है' : 'Your name is required' })} isInvalid={errors.f_name} />
                                        {errors.f_name && (
                                            <Form.Control.Feedback type="invalid">{errors.f_name.message}</Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>                        
                                </Col>
                                <Col md={5}>
                                    <FloatingLabel controlId="f_enrolled" label={appLanguage === 'hi' ? 'नामांकन संख्या' : 'Enrollment no'} className="mb-3">
                                        <Form.Control type="text" {...register('f_enrolled')} />
                                    </FloatingLabel>
                                </Col>
                                <Col md={7}>
                                    <FloatingLabel controlId="f_email" label={appLanguage === 'hi' ? 'ईमेल आईडी' : 'Email id'} className="mb-3">
                                        <Form.Control type="email" {...register('f_email', { required: appLanguage === 'hi' ? 'आपका ई-मेल आवश्यक है' : 'Your email is required',pattern: {value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: appLanguage === 'hi' ? 'अमान्य ईमेल पता' : 'Invalid email address'}})} isInvalid={errors.f_email} />
                                        {errors.f_email && (
                                            <Form.Control.Feedback type="invalid">{errors.f_email.message}</Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>
                                </Col>
                                <Col md={5}>
                                    <FloatingLabel controlId="f_mobile" label={appLanguage === 'hi' ? 'मोबाइल नम्बर' : 'Mobile number'} className="mb-3">
                                        <Form.Control type="tel" maxLength="10" {...register('f_mobile', { required: appLanguage === 'hi' ? 'आपका मोबाइल नंबर आवश्यक है' : 'Your mobile number is required', pattern: { value: /^[6-9]\d{9}$/, message: appLanguage === 'hi' ? 'मोबाइल नंबर 6-9 से प्रारंभ होना चाहिए और 10 अंक लंबा होना चाहिए' : 'Mobile number must start with 6-9 and be 10 digits long' } })} isInvalid={errors.f_mobile} />
                                        {errors.f_mobile && (
                                            <Form.Control.Feedback type="invalid">{errors.f_mobile.message}</Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>
                                </Col>
                                <Col md={12}>
                                    <FloatingLabel controlId="f_address" label={appLanguage === 'hi' ? 'पता' : 'Address'} className="mb-3">
                                        <Form.Control as="textarea" {...register('f_address')} />
                                    </FloatingLabel>
                                </Col>
                                <Col md={4}>
                                    <FloatingLabel controlId="f_course" label={appLanguage === 'hi' ? 'पाठ्यक्रम' : 'Course'} className="mb-3">
                                        <Form.Control type="text" {...register('f_course')} />
                                    </FloatingLabel>
                                </Col>
                                <Col md={4}>
                                    <FloatingLabel controlId="f_branch" label={appLanguage === 'hi' ? 'शाखा' : 'Branch'} className="mb-3">
                                        <Form.Control type="text" {...register('f_branch')} />
                                    </FloatingLabel>
                                </Col>
                                <Col md={4}>
                                    <FloatingLabel controlId="f_batch" label={appLanguage === 'hi' ? 'बैच-वर्ष' : 'Batch-Year'} className="mb-3">
                                        <Form.Control type="text" {...register('f_batch')} />
                                    </FloatingLabel>
                                </Col>
                                <Col md={12}>
                                    <FloatingLabel controlId="f_subject" label={appLanguage === 'hi' ? 'विषय' : 'Subject'} className="mb-3">
                                        <Form.Control type="text" {...register('f_subject', { required: appLanguage === 'hi' ? 'विषय आवश्यक है' : 'Subject is required' })} isInvalid={errors.f_subject} />
                                        {errors.f_subject && (
                                            <Form.Control.Feedback type="invalid">{errors.f_subject.message}</Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>
                                </Col>
                                <Col md={12}>
                                    <FloatingLabel controlId="f_message" label={appLanguage === 'hi' ? 'आपकी शिकायत/प्रतिक्रिया' : 'Your complaint/feedback'} className="mb-3">
                                        <Form.Control as="textarea" rows={4} {...register('f_message', { required: appLanguage === 'hi' ? 'आपका शिकायत/प्रतिक्रिया संदेश आवश्यक है' : 'Your complaint/feedback message is required' })} isInvalid={errors.f_message} />
                                        {errors.f_message && (
                                            <Form.Control.Feedback type="invalid">{errors.f_message.message}</Form.Control.Feedback>
                                        )}
                                    </FloatingLabel>
                                </Col>
                                <Col md={8}>
                                    <FloatingLabel controlId="f_file" label={appLanguage === 'hi' ? 'फ़ाइल संलग्न करें (वैकल्पिक) - DOC, PDF, इमेज, वीडियो - अधिकतम 5MB' : 'Attach a file (optional) - DOC, PDF, image, video - Max 5MB' } className="mb-3 mb-md-0">
                                        <Form.Control type="file" accept=".doc,.docx,.pdf,image/*,video/*" {...register('f_file', {validate: { 
                                            fileSize: (value) => {
                                                const file = value?.[0];
                                                if (!file) return true;
                                                return ( file.size <= 5 * 1024 * 1024 || (appLanguage === 'hi' ? 'फ़ाइल का आकार 5MB से अधिक नहीं होना चाहिए' : 'File size should not exceed 5MB'));
                                            },
                                            fileType: (value) => {
                                                const file = value?.[0];
                                                if (!file) return true;

                                                const allowedTypes = [
                                                    "application/pdf",
                                                    "application/msword",
                                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                    "video/mp4"
                                                ];

                                                // allow all images
                                                if (file.type.startsWith("image/")) return true;

                                                return (
                                                    allowedTypes.includes(file.type) ||
                                                    (appLanguage === "hi"
                                                    ? "केवल DOC, PDF, इमेज, या वीडियो फ़ाइलें स्वीकार्य हैं"
                                                    : "Only DOC, PDF, image, or video files are allowed")
                                                );
                                            }
                                        }})} isInvalid={!!errors.f_file} />
                                        <Form.Control.Feedback type="invalid">{errors.f_file?.message}</Form.Control.Feedback>
                                    </FloatingLabel>
                                </Col>
                                <Col md={4} className="d-grid">
                                    <Button type="submit" size="lg" variant="success" disabled={submitting}>
                                    {submitting ? (
                                        <Stack direction="horizontal" gap={2} className="align-items-center justify-content-center">
                                            <Spinner animation="grow" role="status" variant="warning" size="sm" aria-hidden="true" />
                                            <Spinner animation="grow" role="status" variant="danger" size="sm" aria-hidden="true" />
                                            <Spinner animation="grow" role="status" variant="success" size="sm" aria-hidden="true" />
                                            {appLanguage === 'hi' ? 'प्रेषित हो रहा है...' : 'Submitting...'}
                                        </Stack>
                                    ) : (
                                        appLanguage === 'hi' ? 'सबमिट' : 'Submit'
                                    )}
                                    </Button>
                                </Col>
                            </Row>
                        </form>
                    </Col>
                    <Col md={5}>
                        <form onSubmit={FeedbackDetail}>
                            <h2 className='text-start'>
                                <i className="bi bi-arrow-down-circle"></i> {appLanguage === 'hi' ? 'शिकायत/प्रतिक्रिया स्थिति प्राप्त करें' : 'Get complaint/feedback status'}
                            </h2>
                            <InputGroup size="lg" className="mb-3">
                                <FloatingLabel controlId="complaintNumber" label={appLanguage === 'hi' ? 'संदर्भ संख्या दर्ज करें' : 'Enter reference number'}>
                                    <Form.Control type="text" placeholder="eg: UJFqXjX" onChange={ComplaintNumberChange} value={ComplaintNumber} />
                                </FloatingLabel>
                                <Button type="submit" variant="success">{appLanguage === 'hi' ? 'खोजें' : 'Find'}</Button>
                            </InputGroup>
                            {isLoading ? (
                                <Card>
                                    <Image src={complaintInfo} fluid />
                                </Card>
                            ) : (
                                <Card className='text-start'>
                                    {Complaints.length > 0 ? (
                                    <React.Fragment>
                                    {Complaints.map((f,index)=>(
                                    <Card.Body key={index}>
                                        <Card.Title className='d-flex align-items-center justify-content-between'>
                                            {appLanguage === 'hi' ? 'संदर्भ संख्या' : 'Reference number'} <b className='text-danger'>#{f.f_reference}</b>
                                        </Card.Title>
                                        <div>
                                            <Row>
                                                <Col md="auto" className="text-center text-primary flex-column d-none d-lg-flex">
                                                    <Row className="h-50">
                                                        <Col className="border-2 border-end">&nbsp;</Col>
                                                        <Col>&nbsp;</Col>
                                                    </Row>
                                                    <h5 className="m-2">
                                                        <i className="bi bi-pencil-square"></i>
                                                    </h5>
                                                    <Row className="h-50">
                                                        <Col className="border-2 border-end">&nbsp;</Col>
                                                        <Col>&nbsp;</Col>
                                                    </Row>
                                                </Col>
                                                <Col className="py-2">
                                                    <Card className="border-primary">
                                                        <Card.Body className="text-primary">
                                                            <div className="float-end">{formatDate(f.f_date)}</div>
                                                            <Card.Title>Filled</Card.Title>
                                                            <Accordion defaultActiveKey={0}>
                                                                <Accordion.Item eventKey={0}>
                                                                    <Accordion.Header className='fw-bold'>
                                                                        {appLanguage === 'hi' ? 'शिकायत/प्रतिक्रिया का विवरण' : 'Complaint/feedback details'}
                                                                    </Accordion.Header>
                                                                    <Accordion.Body className='p-0'>
                                                                        <ListGroup variant="flush">                                                                        
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'नाम' : 'Name'}
                                                                                <b className="ms-2">{f.f_name}</b>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'ईमेल आईडी' : 'Email id'}
                                                                                <b className="ms-2">{f.f_email}</b>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'मोबाइल नंबर' : 'Mobile number'}
                                                                                <b className="ms-2">{f.f_mobile}</b>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'नामांकन संख्या' : 'Enrollment Number'}
                                                                                <b className="ms-2">{f.f_enrolled}</b>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='px-0'>
                                                                                {appLanguage === 'hi' ? 'पता' : 'Address'}
                                                                                <div className="fw-bold">{f.f_address}</div>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {t('FeedbackType')}
                                                                                {FeedbackTypes && <b className="ms-2">{LangValue(findItem(FeedbackTypes,'ft_id',f.f_ft_id),'ft_name')}</b>}
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'विभाग' : 'Department'}
                                                                                {DepartmentList && <b className="ms-2">{LangValue(findItem(DepartmentList,'sd_id',f.f_sd_id),'sd_name')}</b>}
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'पाठ्यक्रम' : 'Course'}
                                                                                <b className="ms-2">{f.f_course}</b>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'शाखा' : 'Branch'}
                                                                                <b className="ms-2">{f.f_branch}</b>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='d-flex align-items-center justify-content-between px-0'>
                                                                                {appLanguage === 'hi' ? 'बैच-वर्ष' : 'Batch-Year'}
                                                                                <b className="ms-2">{f.f_batch}</b>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='px-0'>
                                                                                {appLanguage === 'hi' ? 'विषय' : 'Subject'}
                                                                                <div className="fw-bold">{f.f_subject}</div>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='px-0'>
                                                                                {appLanguage === 'hi' ? 'शिकायत का विवरण' : 'Complaint Details'}
                                                                                <div className="fw-bold">{f.f_message}</div>
                                                                            </ListGroup.Item>
                                                                            <ListGroup.Item className='px-0'>
                                                                                {appLanguage === 'hi' ? 'संलग्न फ़ाइल' : 'Attached File'}
                                                                                {f.file && (() => {
                                                                                // 1. Construct and encode the base URL safely
                                                                                const rawPath = `${global.config.uploadPath}${f.file.up_fname}${f.file.up_ext}`;
                                                                                
                                                                                // 2. Validate URL scheme (prevents javascript: or data: injection)
                                                                                const isSafeUrl = rawPath.startsWith('/') || rawPath.startsWith('http://') || rawPath.startsWith('https://');
                                                                                const safePath = isSafeUrl ? encodeURI(rawPath) : '#';

                                                                                return (
                                                                                    <div className="fw-bold mt-2">
                                                                                    {f.file.up_file_type?.startsWith('image/') ? (
                                                                                        <img 
                                                                                        src={safePath} 
                                                                                        alt={f.file.up_oname || 'Uploaded image'} 
                                                                                        className="img-fluid rounded border shadow-sm" 
                                                                                        />
                                                                                    ) : f.file.up_file_type?.startsWith('video/') ? (
                                                                                        <div className="ratio ratio-16x9 rounded border shadow-sm">
                                                                                        <video controls>
                                                                                            <source src={safePath} type={f.file.up_file_type} />
                                                                                            {appLanguage === 'hi' ? 'आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता।' : 'Your browser does not support the video tag.'}
                                                                                        </video>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <a 
                                                                                        href={safePath} 
                                                                                        target="_blank" 
                                                                                        rel="noopener noreferrer" 
                                                                                        className="btn btn-outline-dark btn-sm"
                                                                                        >
                                                                                        {appLanguage === 'hi' ? 'फ़ाइल देखें' : 'View File'} ({f.file.up_ext})
                                                                                        </a>
                                                                                    )}
                                                                                    </div>
                                                                                );
                                                                                })()}
                                                                            </ListGroup.Item>
                                                                        </ListGroup>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>                                        
                                        </div>
                                        {f.logs.map(fl=>(
                                            <Log fl={fl} />
                                        ))}
                                    </Card.Body>
                                    ))}
                                    </React.Fragment>
                                    ) : (
                                    <Card.Body className="d-flex border border-4 bg-success-subtle p-3 align-items-center">
                                        <div className="flex-shrink-0">
                                            <i className="bi bi-info-circle-fill fs-1 text-success"></i>
                                        </div>
                                        <div className="flex-grow-1 ms-3">
                                            <Card.Title>{appLanguage === 'hi' ? 'कोई परिणाम नहीं मिला!' : 'No results found!'}</Card.Title>
                                            <Card.Text>{appLanguage === 'hi' ? 'आपके द्वारा दी गई शिकायत संख्या से हमें कोई जानकारी प्राप्त नहीं हुई।' : 'We did not receive any information from the complaint number provided by you.'}</Card.Text>
                                        </div>
                                    </Card.Body>
                                    )}                                
                                </Card>
                            )}                        
                        </form>
                    </Col>
                </Row>
            </Container>
        </section>
    );
    
}
export default Complaint;

const Log = ({fl}) => 
{
    const appLanguage = (localStorage.getItem('appLanguage') === null) ? 'en' : localStorage.getItem('appLanguage');
    return (
        <div>
        {fl.fl_status === 1 ? (
            <Row>
                <Col md="auto" className="text-center text-primary flex-column d-none d-lg-flex">
                    <Row className="h-50">
                        <Col className="border-2 border-end">&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <h5 className="m-2">
                        <i className="bi bi-app-indicator"></i>                                                        
                    </h5>
                    <Row className="h-50">
                        <Col className="border-2 border-end">&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                </Col>
                <Col className="py-2">
                    <Card className="border-primary">
                        <Card.Body className="text-primary">
                            <div className="float-end">{formatDate(fl.fl_date)}</div>
                            <Card.Title>{appLanguage === 'hi' ? 'सौंपा गया' : 'Assigned'}</Card.Title>
                            <Card.Text>{fl.fl_comment}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        ) : null}
        {fl.fl_status === 2 ? (
            <Row>
                <Col md="auto" className="text-center text-danger flex-column d-none d-lg-flex">
                    <Row className="h-50">
                        <Col className="border-2 border-end">&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <h5 className="m-2">
                        <i className="bi bi-app-indicator"></i>                                                        
                    </h5>
                    <Row className="h-50">
                        <Col className="border-2 border-end">&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                </Col>
                <Col className="py-2">
                    <Card className="border-danger">
                        <Card.Body className="text-danger">
                            <div className="float-end">{formatDate(fl.fl_date)}</div>
                            <Card.Title>{appLanguage === 'hi' ? 'विचाराधीन' : 'Pending'}</Card.Title>
                            <Card.Text>{fl.fl_comment}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        ) : null}
        {fl.fl_status === 3 ? (
            <Row>
                <Col md="auto" className="text-center text-success flex-column d-none d-lg-flex">
                    <Row className="h-50">
                        <Col className="border-2 border-end">&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                    <h5 className="m-2">
                        <i className="bi bi-check2-square"></i>                                                       
                    </h5>
                    <Row className="h-50">
                        <Col className="border-2 border-end">&nbsp;</Col>
                        <Col>&nbsp;</Col>
                    </Row>
                </Col>
                <Col className="py-2">
                    <Card className="border-success">
                        <Card.Body className="text-success">
                            <div className="float-end">{formatDate(fl.fl_date)}</div>
                            <Card.Title>{appLanguage === 'hi' ? 'पूरा किया हुआ' : 'Completed'}</Card.Title>
                            <Card.Text>{appLanguage === 'hi' ? 'आपकी शिकायत का समाधान कर दिया गया है.' : 'Your complaint has been resolved.'}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        ) : null}                                        
        </div>
    );
}